import classnames from 'classnames';
import React, {
  ChangeEventHandler,
  FocusEventHandler,
  ReactNode,
  useState
} from 'react';

import { ErrorMessages } from 'common/components/Form/ErrorMessages';

import './styles.scss';

export type InputProps = {
  additionalText?: ReactNode;
  className?: string;
  containerClassName?: string;
  disabled?: boolean;
  errorClassName?: string;
  errors?: string[];
  helpText?: string;
  helpTextOnFocus?: boolean;
  label?: string;
  labelClassName?: string;
  name?: string;
  onBlur?: FocusEventHandler<HTMLInputElement>;
  onChange?: ChangeEventHandler<HTMLInputElement>;
  placeholder?: string;
  type?: string;
  validated?: boolean;
  validating?: boolean;
  value?: string;
};

const Input = ({
  additionalText,
  className,
  containerClassName,
  disabled = false,
  errorClassName,
  errors,
  helpText,
  helpTextOnFocus = false,
  label,
  labelClassName,
  name,
  onBlur,
  onChange,
  placeholder,
  type = 'text',
  validated,
  validating,
  value = ''
}: InputProps) => {
  const [isFocused, setIsFocused] = useState(false);

  const handleFocus = () => setIsFocused(true);

  const handleBlur = (e: React.FocusEvent<HTMLInputElement, Element>) => {
    setIsFocused(false);
    onBlur?.(e);
  };

  const displayHelp = helpText && (!helpTextOnFocus || isFocused || errors);

  return (
    <fieldset
      className={classnames('userspace-input-fieldset', containerClassName, {
        'icon-tick-a': validated,
        icon: validated,
        validated: validated,
        validating: validating
      })}
    >
      {label && (
        <div className="userspace-input-label-container">
          <label className={classnames('userspace-label', labelClassName)}>
            {label}
          </label>
          {additionalText}
        </div>
      )}
      <input
        className={classnames('userspace-input', className, {
          error: errors
        })}
        disabled={disabled}
        name={name}
        onBlur={handleBlur}
        onChange={onChange}
        onFocus={handleFocus}
        placeholder={placeholder}
        type={type}
        value={value}
      />
      {errors && (
        <ErrorMessages
          className={classnames(
            'userspace-input-error-message',
            errorClassName
          )}
          messages={errors}
        />
      )}
      {displayHelp && <div className="help-text">{helpText}</div>}
    </fieldset>
  );
};

export default Input;
